import CircularProgress from '@mui/material/CircularProgress';
import { useGlobalStore } from '../../stores/globalStore';

/**
 * Semi-transparent overlay displayed during facility switching.
 * Covers the main content area to indicate that data is being refreshed.
 * Renders nothing when not switching.
 */
export default function FacilitySwitchOverlay() {
  const isSwitching = useGlobalStore((s) => s.isSwitchingFacility);
  const facilityName = useGlobalStore((s) => s.facilityName);

  if (!isSwitching) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 2000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        background: 'rgba(0, 0, 0, 0.45)',
        backdropFilter: 'blur(4px)',
        animation: 'facilitySwitchFadeIn 150ms ease-out',
      }}
    >
      <style>{`
        @keyframes facilitySwitchFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes facilitySwitchPulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.05); opacity: 0.8; }
        }
      `}</style>
      <div
        style={{
          background: 'var(--card-bg, #fff)',
          borderRadius: 12,
          padding: '32px 48px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16,
          boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
          animation: 'facilitySwitchPulse 1.5s ease-in-out infinite',
        }}
      >
        <CircularProgress size={32} sx={{ color: 'var(--brand-accent)' }} />
        <div style={{ fontSize: 'var(--font-size-base)', fontWeight: 600, color: 'var(--text-primary, #333)' }}>
          Switching facility...
        </div>
        {facilityName && (
          <div style={{ fontSize: 'var(--font-size-base)', color: 'var(--text-secondary, #666)' }}>
            {facilityName}
          </div>
        )}
      </div>
    </div>
  );
}
